module.exports = __webpack_public_path__ + "static/media/country_ky.ead51c72.webp";